<template>
  <div class="request-card">
    <div class="display-flex">
      <Avatar :size="50" :url="`${BASE_PATH}${avatar}`"></Avatar>
      <div class="display-flex flex-column">
        <div class="request-card-username">{{ name }}</div>
        <div class="request-card-date">
          <span class="dot"></span>
          <!-- <f7-icon material="schedule" color="gray" size="14"></f7-icon> -->
          <Countup :start="start"></Countup>
        </div>
        <!-- <div class="request-card-meta-item">{{ language }} · {{ level }}</div> -->
        <div class="request-card-meta-item">{{ level }}</div>
        <f7-button fill round color="green" class="margin-top" @click="$emit('accept-request', id)">
          Start consultation
        </f7-button>
      </div>
    </div>

    <!-- <div class="request-card-meta">
      <div class="request-card-meta-item">
        <f7-icon material="comment" size="18"></f7-icon>
        {{ language }}
      </div>

      <div class="request-card-meta-item">
        <f7-icon material="school" size="18"></f7-icon>
        {{ level }}
      </div>
    </div> -->

    <!-- <f7-button
      fill
      large
      color="green"
      class="margin-top"
      @click="$emit('accept-request', id)"
    >
      Start consultation
    </f7-button> -->
  </div>
</template>

<script>
import { BASE_PATH } from '@/js/constants/index.js';

import Avatar from '@/components/Avatar.vue';
import Countup from '@/components/Countup.vue';

export default {
  name: 'RequestCard',

  components: {
    Avatar,
    Countup
  },

  props: {
    id: {
      type: Number
    },

    languageId: {
      type: Number
    },

    levelId: {
      type: Number
    },

    start: {
      type: String
    },

    name: {
      type: String,
      default: ''
    },

    avatar: {
      type: String,
      default: ''
    }
  },

  computed: {
    BASE_PATH: () => BASE_PATH,

    language() {
      return this.$store.state.languages.find(language => language.id === this.languageId).name;
    },

    level() {
      return this.$store.state.levels.find(level => level.id === this.levelId).name;
    }
  }
};
</script>

<style lang="scss" scoped>
.request-card {
  padding: 15px 15px;
  width: 100%;
  background: #ffffff;
  border: 1px solid #d8d8d8;

  border-left: 0;
  border-right: 0;

  /* border-radius: 8px; */
  box-sizing: border-box;

  /* --f7-button-border-radius: 8px; */
  /* --f7-button-large-height: 40px; */
  /* --f7-button-box-shadow: none; */
  --f7-button-min-width: 150px;

  .avatar {
    margin-right: 10px;
  }

  &-username {
    margin-bottom: 5px;
    font-size: 15px;
    color: #000000;
    line-height: 1.07;
  }

  &-date {
    line-height: 1;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: rgba(#5a6169, 0.6);

    /* .icon {
      margin-right: 5px;
    } */

    .dot {
      width: 12px;
      height: 12px;
      margin-right: 5px;
      border-radius: 50%;
      background-color: #ff001f;
    }
  }

  &-meta {
    display: flex;
    align-items: center;
    margin-top: 15px;

    &-item {
      margin-top: 5px;
      font-size: 15px;
      color: #000000;
      line-height: 1;

      &:first-child {
        max-width: 120px;
        width: 100%;
      }

      .icon {
        margin-right: 7px;
      }
    }
  }

  .button {
    font-weight: 500 !important;
  }
}
</style>
